import { render, staticRenderFns } from "./TrustpilotTable.vue?vue&type=template&id=2923d333&"
import script from "./TrustpilotTable.vue?vue&type=script&lang=js&"
export * from "./TrustpilotTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports